import { useQuery } from '@tanstack/react-query';
import apiClient from './apiClient';

const providerKeys = {
  all: ['providers'],
  list: () => [...providerKeys.all, 'list'],
};

export const useProviders = (options = {}) => {
  return useQuery({
    queryKey: providerKeys.list(),
    queryFn: async () => {
      const response = await apiClient.get('legal_entities/providers');
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    ...options,
  });
};

export default providerKeys;
